// pages/admin/NewsCategoriesPage.jsx (новий файл-обгортка)
import React, { useState } from 'react';
import NewsCategoriesAdmin from '../../../kindergartens/detail/components/News/NewsCategoriesAdmin';

const NewsCategoriesPage = () => {
  const [open, setOpen] = useState(true);
  // якщо це окрема сторінка (не модалка) — можна відкрити одразу
  return open ? (
    <NewsCategoriesAdmin onClose={() => setOpen(false)} />
  ) : null;
};

export default NewsCategoriesPage;